import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import headerLogo from "../assets/images/headerlogo.png";
import himalayaLogo from "../assets/images/himalayblack.png";
import vartohLogo from "../assets/images/vartohlogo.avif";
import headerBg from "../assets/images/headerbg.jpg";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isShopDropdownOpen, setIsShopDropdownOpen] = useState(false);
  const location = useLocation(); // Get the current route

  const handleScroll = (event, sectionId) => {
    event.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false); // Close menu on mobile after clicking
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".shop-dropdown")) {
        setIsShopDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // const toggleMobileMenu = () => {
  //   setIsMobileMenuOpen(!isMobileMenuOpen);
  //   if (isShopDropdownOpen) setIsShopDropdownOpen(false);
  // };

  const toggleShopDropdown = (e) => {
    e.stopPropagation();
    setIsShopDropdownOpen(!isShopDropdownOpen);
  };

  // Check if the current route is not the home route
  const isHomeRoute = location.pathname === "/";

  return (
    <header className={`site-header ${isHomeRoute ? "" : "blog-header"} `}>
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src={headerLogo} alt="Site Logo" />
          </Link>
        </div>

        {/* Render the full header only on the home route */}
        {isHomeRoute && (
          <>
            <nav className={`nav-menu ${isMobileMenuOpen ? "active" : ""}`}>
              <div className="nav-item">
                <a href="#section1" onClick={(e) => handleScroll(e, "section1")}>
                  Home
                </a>
              </div>
              <div className="nav-item">
                <a href="#section2" onClick={(e) => handleScroll(e, "section2")}>
                  About
                </a>
              </div>

              <div className="nav-item">
                <a href="#section3" onClick={(e) => handleScroll(e, "section3")}>
                  Services
                </a>
              </div>
              <div
                className={`nav-item shop-dropdown ${
                  isShopDropdownOpen ? "active" : ""
                }`}
              >
                <Link to="#" onClick={toggleShopDropdown}>
                  Online Shop
                </Link>
                <div
                  className={`shop-content ${
                    isShopDropdownOpen ? "active" : ""
                  }`}
                  style={{
                    "--header-bg": `url("${headerBg}")`,
                  }}
                >
                  <div className="shops-container">
                    <div className="shop-item">
                      <img
                        src={himalayaLogo}
                        alt="Himalay Frsh"
                        className="shop-logo"
                      />

                      <p className="shop-description">
                        Experience the authentic taste of Himalayan organic
                        products. Fresh, natural, and sustainably sourced from
                        the heart of the Himalayas.
                      </p>
                      <a
                        href="https://himalayfrsh.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="visit-btn"
                      >
                        Visit Store
                      </a>
                    </div>
                    <div className="shop-item">
                      <img
                        src={vartohLogo}
                        alt="Vartoh Organic"
                        className="shop-logos"
                      />

                      <p className="shop-description">
                        Discover Premium Organic products from Vartoh Organic.
                        Carefully selected and certified organic items for your
                        healthy lifestyle.
                      </p>
                      <a
                        href="https://www.vartohorganic.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="visit-btn"
                      >
                        Visit Store
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nav-item">
                <a href="#section6" onClick={(e) => handleScroll(e, "contact")}>
                  Contact
                </a>
              </div>
              <div className="nav-item">
                <Link to="/products">Products</Link>
              </div>
            </nav>
            <div className="email">
              <a href="mailto:info@mevedir.com">info@mevedir.com</a>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
